export default "__VITE_ASSET__DtY$$PL3__"